<template>
  <v-treeview :items="structure" :active="computedValue" item-key="treeviewId" open-all class="pb-5">
    <template #label="{ item }">
      <v-row no-gutters class="align-center" @click="onActiveUpdate(item.treeviewId)">
        <v-col cols="auto">
          <span class="text-body-2">
            {{ item.translatedType }}
          </span>
        </v-col>
        <v-col cols="auto" class="pl-1" v-if="item.isMain || item.displayNumber">
          <span class="text-caption font-italic font-weight-light pa-0">
            <template v-if="item.isMain">
              {{ mainTranslation }}
            </template>
            <template v-else> ({{ item.displayNumber }}) </template>
          </span>
        </v-col>
      </v-row>
    </template>
    <template #append="{item}">
      <v-row no-gutters class="align-center" @click="onActiveUpdate(item.treeviewId)">
        <v-col cols="auto" v-if="item.displayName">
          <v-tooltip bottom color="font">
            <template #activator="{ on }">
              <v-chip v-on="on" color="primary" label small>
                {{ item.displayName }}
              </v-chip>
            </template>
            {{ badgeTranslation }}
          </v-tooltip>
        </v-col>
        <v-col cols="auto">
          <dots-menu
            :disabled="isEditingOn"
            :items="item.dotsItems"
            @edit="onEdit(item.datasource, item.treeviewId)"
            @delete="$emit('delete', item.id, item.datasource)"
            @addPickArm="$emit('addSubfeature', item.id, item.datasource)"
            @addHead="$emit('addSubfeature', item.id, item.datasource)"
            @addCircuit="$emit('addSubfeature', item.id, item.datasource)"
          >
          </dots-menu>
        </v-col>
      </v-row>
    </template>
  </v-treeview>
</template>

<script>
import DotsMenu from '@/components/DotsMenu';

export default {
  name: 'LampTreeview',
  components: {
    DotsMenu,
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    structure: {
      type: Array,
      required: true,
    },
    featureId: {
      type: [Number, String],
      required: true,
    },
    isEditingOn: {
      type: Boolean,
      required: true,
    },
    badgeTranslation: {
      type: String,
      required: true,
    },
  },
  computed: {
    computedValue() {
      return [this.value];
    },
    mainTranslation() {
      return `(${this.$i18n.t('sidebar.zdmLamp.main')})`;
    },
  },
  methods: {
    onActiveUpdate(value) {
      if (this.isEditingOn) {
        return;
      }
      this.$emit('input', value);
    },
    onEdit(datasource, treeviewId) {
      if (this.value !== treeviewId) {
        this.$emit('input', treeviewId);
      }
      this.$emit('edit', datasource);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-treeview-node__root {
    cursor: pointer;
  }
  .v-treeview-node--active {
    &::after {
      position: absolute;
      left: 0;
      top: 0;
      width: 4px;
      background-color: #1a73e8;
    }
  }
}
</style>
